<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary" aria-label="확인 중"></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
const { normalizeTravelerCode } = require("@/util/travelerAttribution")

export default {
  async created() {
    const code = normalizeTravelerCode(this.$route.params.code)
    if (!code) return this.rejectEntry()
    try {
      const response = await this.$http.get(`/api/promotion/select/travelers/public/${encodeURIComponent(code)}`)
      if (!response.data || response.data.code !== code) return this.rejectEntry()
      await this.$router.replace({ path: "/", query: { ...this.$route.query, traveler: code } })
    } catch (error) {
      this.rejectEntry()
    }
  },
  methods: {
    rejectEntry() {
      alert("사용할 수 없는 제휴 링크입니다.")
      this.$router.replace("/").catch(() => {})
    },
  },
}
</script>
